import { injectable } from 'inversify';

import { OperationResult, Success } from '@vp/common/core/OperationResult';
import { ProfileManagerState } from '@vp/manager/profile/core/interface/ProfileManagerState';

import { GalleryManagerRepository } from '../interface/GalleryManagerRepository';

@injectable()
export class MakeLiveUsecase {
  constructor(
    private readonly galleryManagerRepository: GalleryManagerRepository,
    private readonly profileManagerState: ProfileManagerState,
  ) {}

  async execute(photoId: string, controller?: AbortController): Promise<OperationResult> {
    const result = await this.galleryManagerRepository.makeLive(photoId, controller);

    if (result instanceof Success) {
      const [photo, liveMedia] = result.value;
      this.profileManagerState.updatePhoto(photo);
      this.profileManagerState.updateLiveMedia(liveMedia);
    }

    return result as OperationResult;
  }
}
